import Vue from "vue";
import VueRouter from "vue-router";
import { Trans } from "@/plugins/i18n/translationHandler";
import store from "@/store";

const load = (component, isView = true) => {
  if (isView) return () => import(`@/views/${component}.vue`);
  return () => import(`@/components/${component}.vue`);
};

const routes = [
  {
    path: "/:locale",
    component: load("utils/PassThrough"),
    beforeEnter: Trans.routeMiddleware,
    children: [
      {
        path: "/",
        name: "Hotellerie",
        component: load("Hotellerie/Dashboard"),
      },
      {
        path: "hesta/factsheets",
        name: "Factsheets",
        component: load("Hotellerie/Factsheets"),
        /*beforeEnter: (to, from, next) => {    
          if(!store.getters['auth/isLoggedIn']) next(from.path === to.path ? '/' : from.path)
          else next()
        },*/
      },
      {
        path: "hesta/markets",
        name: "Markets",
        component: load("Hotellerie/Markets"),
        /*beforeEnter: (to, from, next) => {    
          if(!store.getters['auth/isLoggedIn']) next(from.path === to.path ? '/' : from.path)
          else next()
        },*/
      },
      {
        path: "hesta/benchmark",
        name: "Benchmark",
        component: load("Hotellerie/Benchmark"),
        /*beforeEnter: (to, from, next) => {    
          if(!store.getters['auth/isLoggedIn']) next(from.path === to.path ? '/' : from.path)
          else next()
        },*/
      },
      {
        path: "airdna/offer",
        name: "AirdnaOffer",
        component: load("Airdna/Offer"),
      },
      {
        path: "airdna/demand",
        name: "AirdnaDemand",
        component: load("Airdna/Demand"),
      },
      {
        path: "airdna/revenues",
        name: "AirdnaRevenues",
        component: load("Airdna/Revenues"),
        beforeEnter: (to, from, next) => {
          if (!store.getters["auth/isLoggedIn"]) {
            if (store.getters["auth/hasPermission"])
              next(from.path === to.path ? "/" : from.path);
            else {
              store.dispatch("auth/logout");
              next("/de/Login");
            }
          } else next("/");
        },
      },
      {
        path: "MobilityInsights/:id",
        name: "MobilityInsightsReport",
        component: load("MIP/Reporting"),
        beforeEnter: (to, from, next) => {
          if (!store.getters["auth/isLoggedIn"])
            next(from.path === to.path ? "/" : from.path);
          else {
            if (store.getters["auth/hasPermission"]) next();
            else {
              store.dispatch("auth/logout");
            }
          }
        },
      },
      {
        path: "MobilityInsights/faq",
        name: "MobilityInsightsFaq",
        component: load("MIP/faq"),
        beforeEnter: (to, from, next) => {
          if (!store.getters["auth/isLoggedIn"])
            next(from.path === to.path ? "/" : from.path);
          else {
            if (store.getters["auth/hasPermission"]) next();
            else {
              store.dispatch("auth/logout");
            }
          }
        },
      },
      {
        path: "settings",
        name: "Settings",
        component: load("user/Settings"),
        beforeEnter: (to, from, next) => {
          if (!store.getters["auth/isLoggedIn"])
            next(from.path === to.path ? "/" : from.path);
          else {
            if (store.getters["auth/hasPermission"]) next();
            else {
              store.dispatch("auth/logout");
              next("/de/Login");
            }
          }
        },
      },
      {
        path: "admin",
        name: "Admin",
        component: load("user/Admin"),
        beforeEnter: (to, from, next) => {
          if (!store.getters["auth/isLoggedIn"])
            next(from.path === to.path ? "/" : from.path);
          else {
            if (store.getters["auth/hasPermission"]) next();
            else {
              store.dispatch("auth/logout");
              next("/de/Login");
            }
          }
        },
      },
      {
        path: "login",
        name: "Login",
        component: load("Login/Login"),
        beforeEnter: (to, from, next) => {
          if (store.state.auth.token) {
            next("/");
          } else {
            next();
          }
        },
      },
      {
        path: "DemandResetPassword",
        name: "DemandResetPassword",
        component: load("Login/DemandResetPassword"),
        beforeEnter: (to, from, next) => {
          if (store.state.auth.token) {
            next("/");
          } else {
            next();
          }
        },
      },
      {
        path: "account/ResetPassword/:userHash/:token",
        name: "ResetPassword",
        component: load("Login/ResetPassword"),
        beforeEnter: (to, from, next) => {
          if (store.state.auth.token) {
            next("/");
          } else {
            next();
          }
        },
      },
    ],
  },
  {
    path: "*",
    redirect: () => Trans.defaultLocale,
  },
];

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
